import PropTypes from 'prop-types';
import React from 'react';

import { Col } from 'react-bootstrap';

class RightSide extends React.Component {
    render() {
        return (
            <Col xs={3} sm={3} md={3} lg={3} className={this.props.addClass}>
                {this.props.children}
            </Col>
        );
    }
}

RightSide.propTypes = {
    addClass: PropTypes.string,
};

RightSide.defaultProps = {
    addClass: 'col-right',
};

export default RightSide;
